// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-empty {
  --perxis-auto-empty-title-font-size-xxs-xs-inner: var(--perxis-auto-empty-title-font-size-xxs-xs, 20px);
  --perxis-auto-empty-title-line-height-xxs-xs-inner: var(
    --perxis-auto-empty-title-line-height-xxs-xs,
    var(--perxis-auto-root-typography-h2-line-height-xs-inner)
  );
  --perxis-auto-empty-title-font-size-sm-xxl-inner: var(--perxis-auto-empty-title-font-size-sm-xxl, 28px);
  --perxis-auto-empty-title-line-height-sm-xxl-inner: var(
    --perxis-auto-empty-title-line-height-sm-xxl,
    var(--perxis-auto-root-typography-h2-line-height-xxl-inner)
  );
  --perxis-auto-empty-title-font-weight-inner: var(
    --perxis-auto-empty-title-font-weight,
    var(--perxis-auto-root-typography-h2-font-weight-inner)
  );
  --perxis-auto-empty-title-letter-spacing-inner: var(
    --perxis-auto-empty-title-letter-spacing,
    var(--perxis-auto-root-typography-h2-letter-spacing-inner)
  );
  --perxis-auto-empty-title-text-transform-inner: var(
    --perxis-auto-empty-title-text-transform,
    var(--perxis-auto-root-typography-h2-text-transform-inner)
  );
  --perxis-auto-empty-title-color-inner: var(
    --perxis-auto-empty-title-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-empty-description-font-size-xxs-xs-inner: var(--perxis-auto-empty-description-font-size-xxs-xs, 14px);
  --perxis-auto-empty-description-line-height-xxs-xs-inner: var(
    --perxis-auto-empty-description-line-height-xxs-xs,
    var(--perxis-auto-root-typography-main-line-height-xs-inner)
  );
  --perxis-auto-empty-description-font-size-sm-xxl-inner: var(--perxis-auto-empty-description-font-size-sm-xxl, 16px);
  --perxis-auto-empty-description-line-height-sm-xxl-inner: var(
    --perxis-auto-empty-description-line-height-sm-xxl,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-empty-description-font-weight-inner: var(
    --perxis-auto-empty-description-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-empty-description-letter-spacing-inner: var(
    --perxis-auto-empty-description-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-empty-description-text-transform-inner: var(
    --perxis-auto-empty-description-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-empty-description-color-inner: var(
    --perxis-auto-empty-description-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  --perxis-auto-empty-background-color-inner: var(
    --perxis-auto-empty-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-empty-border-color-inner: var(
    --perxis-auto-empty-color-width,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-empty-padding-inner: var(
    --perxis-auto-empty-padding,
    var(--perxis-auto-gap-vertical-yellow-inner) 18px var(--perxis-auto-gap-vertical-yellow-inner) 18px
  );
  --perxis-auto-empty-border-radius-inner: var(--perxis-auto-empty-border-radius, 16px);
  --perxis-auto-empty-border-width-inner: var(--perxis-auto-empty-border-width, 0);
  background-color: var(--perxis-auto-empty-background-color-inner);
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_16_13-empty[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_13-empty > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_13-empty .ant-5_17_0-wave {
  transition: none !important;
}
.perxis-auto-1_16_13-empty.ant-5_17_0-empty {
  margin: 0;
  border-radius: var(--perxis-auto-empty-border-radius-inner);
  border-width: var(--perxis-auto-empty-border-width-inner);
  border-color: var(--perxis-auto-empty-border-color-inner);
  padding: var(--perxis-auto-empty-padding-inner);
  text-align: center;
}
.perxis-auto-1_16_13-empty.ant-5_17_0-empty.perxis-auto-1_16_13-empty-align-left {
  text-align: left;
}
.perxis-auto-1_16_13-empty.ant-5_17_0-empty.perxis-auto-1_16_13-empty-align-center {
  text-align: center;
}
.perxis-auto-1_16_13-empty.ant-5_17_0-empty.perxis-auto-1_16_13-empty-align-right {
  text-align: right;
}
.perxis-auto-1_16_13-empty.ant-5_17_0-empty .ant-5_17_0-empty-image {
  display: none;
}
.perxis-auto-1_16_13-empty.ant-5_17_0-empty .ant-5_17_0-empty-footer {
  margin-top: var(--perxis-auto-gap-vertical-sky-inner);
}
.perxis-auto-1_16_13-empty {
  --perxis-auto-typography-h2-font-weight: var(--perxis-auto-empty-title-font-weight-inner);
  --perxis-auto-typography-h2-letter-spacing: var(--perxis-auto-empty-title-letter-spacing-inner);
  --perxis-auto-typography-h2-text-transform: var(--perxis-auto-empty-title-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-empty-title-color-inner);
  --perxis-auto-typography-h2-font-size-xxs: var(--perxis-auto-empty-title-font-size-xxs-xs-inner);
  --perxis-auto-typography-h2-font-size-xs: var(--perxis-auto-empty-title-font-size-xxs-xs-inner);
  --perxis-auto-typography-h2-font-size-sm: var(--perxis-auto-empty-title-font-size-sm-xxl-inner);
  --perxis-auto-typography-h2-font-size-md: var(--perxis-auto-empty-title-font-size-sm-xxl-inner);
  --perxis-auto-typography-h2-font-size-lg: var(--perxis-auto-empty-title-font-size-sm-xxl-inner);
  --perxis-auto-typography-h2-font-size-xl: var(--perxis-auto-empty-title-font-size-sm-xxl-inner);
  --perxis-auto-typography-h2-font-size-xxl: var(--perxis-auto-empty-title-font-size-sm-xxl-inner);
  --perxis-auto-typography-h2-line-height-xxs: var(--perxis-auto-empty-title-line-height-xxs-xs-inner);
  --perxis-auto-typography-h2-line-height-xs: var(--perxis-auto-empty-title-line-height-xxs-xs-inner);
  --perxis-auto-typography-h2-line-height-sm: var(--perxis-auto-empty-title-line-height-sm-xxl-inner);
  --perxis-auto-typography-h2-line-height-md: var(--perxis-auto-empty-title-line-height-sm-xxl-inner);
  --perxis-auto-typography-h2-line-height-lg: var(--perxis-auto-empty-title-line-height-sm-xxl-inner);
  --perxis-auto-typography-h2-line-height-xl: var(--perxis-auto-empty-title-line-height-sm-xxl-inner);
  --perxis-auto-typography-h2-line-height-xxl: var(--perxis-auto-empty-title-line-height-sm-xxl-inner);
}
.perxis-auto-1_16_13-empty {
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-empty-description-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-empty-description-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-empty-description-text-transform-inner);
  --perxis-auto-typography-color-dark: var(--perxis-auto-empty-description-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-empty-description-font-size-xxs-xs-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-empty-description-font-size-xxs-xs-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-empty-description-font-size-sm-xxl-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-empty-description-font-size-sm-xxl-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-empty-description-font-size-sm-xxl-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-empty-description-font-size-sm-xxl-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-empty-description-font-size-sm-xxl-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-empty-description-line-height-xxs-xs-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-empty-description-line-height-xxs-xs-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-empty-description-line-height-sm-xxl-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-empty-description-line-height-sm-xxl-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-empty-description-line-height-sm-xxl-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-empty-description-line-height-sm-xxl-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-empty-description-line-height-sm-xxl-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
